import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Notfound } from './core/components/notfound/notfound';

@NgModule({
  imports: [RouterModule.forRoot([
    { path: '', redirectTo: '', pathMatch: 'full' },
    { path: '', loadChildren: () => import('./features/landing/landing-module').then(m => m.LandingModule) },
    { path: 'admin', loadChildren: () => import('./features/admin/admin-routing-module').then(m => m.AdminRoutingModule) },
    { path: 'client', loadChildren: () => import('./features/client/client-routing-module').then(m => m.ClientRoutingModule) },
    { path: 'auth', loadChildren: () => import('./features/auth/auth-routing.module').then(m => m.AuthRoutingModule) },
    { path: 'notfound', component: Notfound },
    // { path: '**', redirectTo: '/notfound' }
    
  ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
